import React from "react";
import { Link } from "react-router-dom";

const Topbar = () => {
  return (
    <div className="bg-dark text-end py-2 px-4 topbar">
      <Link to="/login" className="btn-sm me-2" style={{color:'white', textDecoration:'none'}}>
        Login
      </Link> &nbsp; 

      <Link to="/register" className="btn-sm" style={{color:'white', textDecoration:'none'}}>
        Register
      </Link>
    </div>
  );
};

export default Topbar;